import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["checkbox", "checkboxAll", "memberCount", "notice", "btnSendAll"];
  static values = {
    available: { type: Number, default: 0 },
    totalMemberChecked: { type: Number, default: 0 },
    companyUserId: { type: Number, default: 0 },
  }

  connect() {
    this.isCandidateNote = !!location.pathname.match(/candidatenotes/);
    this.definedCookieName();
    this.checkboxRecheckedFromCookie();
  }

  checkOne() {
    let checked = event.target.checked;
    if (this.hasCheckboxAllTarget) {
      let totalChecked = this.checkboxTargets.filter(cb => cb.checked).length;
      this.checkboxAllTarget.checked = totalChecked === this.checkboxTargets.length;
    }
    this.totalMemberCheckedValue = checked ? (this.totalMemberCheckedValue + 1) : (this.totalMemberCheckedValue - 1);
    this.assignTotalMemberChecked();
    this.alertScoutReached();
    this.setCookie();
  }

  checkAll() {
    if (!this.hasCheckboxTarget) return;

    let checked = event.target.checked;
    this.totalMemberCheckedValue = checked ? this.checkboxTargets.length : 0;
    this.checkboxTargets.forEach(element => { element.checked = checked });
    this.assignTotalMemberChecked();
    this.alertScoutReached();
    this.setCookie();
  }

  assignTotalMemberChecked() {
    if (!this.hasMemberCountTarget) return;
    this.memberCountTarget.textContent = this.totalMemberCheckedValue;
  }

  alertScoutReached() {
    let isOverLimit = this.totalMemberCheckedValue > this.availableValue;

    if (this.hasNoticeTarget) {
      this.noticeTarget.classList.toggle('alert', isOverLimit);
      this.noticeTarget.classList.toggle('alert-danger', isOverLimit);
      if (isOverLimit) window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (this.hasBtnSendAllTarget) this.btnSendAllTarget.classList.toggle('disabled', isOverLimit);
  }

  setCookie() {
    if (!this.isCandidateNote) return;
    let checkboxValues = this.checkboxTargets.filter(el => el.checked).map(el => el.value);
    Cookies.set(this.selectedMemberCookieName, checkboxValues.join(','));
  }

  checkboxRecheckedFromCookie() {
    if (!this.isCandidateNote) return;

    let cookie = Cookies.get(this.selectedMemberCookieName);
    if (!cookie) return;

    let checkboxValues = cookie.split(',');
    if (this.hasCheckboxAllTarget) this.checkboxAllTarget.checked = (checkboxValues.length === this.checkboxTargets.length);

    this.checkboxTargets.forEach(el => {
      el.checked = checkboxValues.includes(el.value);
    });

    this.totalMemberCheckedValue = checkboxValues.length;
    this.assignTotalMemberChecked();
    this.alertScoutReached();
  }

  definedCookieName() {
    if (this.isCandidateNote) this.selectedMemberCookieName = `dj_candidate_note_${this.companyUserIdValue}`
  }

  clearCookie() {
   if (Cookies.get(this.selectedMemberCookieName)) Cookies.remove(this.selectedMemberCookieName);
  }
}
